import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }) => (
  <div className="app-shell">
    <div className="sticky top-0 z-50 px-3 pt-3 sm:px-5">
      <Navbar />
    </div>
    <main className="page-shell flex-1 pb-16">{children}</main>
    <Footer />
  </div>
);

export default Layout;
